/**
 * @generated SignedSource<<9da59607f2a502f392ea15d30c2ab905>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type PlayerType = "CUSTOMER" | "GUEST" | "MEMBER";
export type RateType = "CUSTOMER" | "GUEST" | "LESSON" | "MEMBER";
export type TransportationCode = "CADDIE" | "CADDIE_CART" | "CART" | "FULL_CART" | "MOTOR_PULL_CART" | "PRIVATE_CART" | "PULL_CART" | "SINGLE_CART" | "WALK";
export type VisibilityStatus = "ALL" | "NONE" | "QUALIFYING";
export type useGetBundledRateOptionsQuery$variables = {
  membershipTypeId?: string | null | undefined;
  nonPlayingHost?: boolean | null | undefined;
  rateType: RateType;
  timeSlotId: string;
  transportationMemberId?: string | null | undefined;
  transportationPlayerType?: PlayerType | null | undefined;
  visibleToMembershipTypeId?: string | null | undefined;
};
export type useGetBundledRateOptionsQuery$data = {
  readonly slot: {
    readonly __typename: string;
    readonly agenda?: {
      readonly facility: {
        readonly club: {
          readonly supportsPrivate: boolean;
        } | null | undefined;
      };
    };
    readonly rates?: ReadonlyArray<{
      readonly eighteenHolePrice: number | null | undefined;
      readonly nineHolePrice: number | null | undefined;
      readonly rate: {
        readonly appliesToMembershipType: boolean | null | undefined;
        readonly id: string;
        readonly name: string;
        readonly visibility: VisibilityStatus;
      };
    } | null | undefined> | null | undefined;
    readonly transportationTypes?: ReadonlyArray<{
      readonly code: TransportationCode | null | undefined;
      readonly customCode: string | null | undefined;
      readonly eighteenHolePrice: number | null | undefined;
      readonly enabled: boolean;
      readonly id: string;
      readonly name: string | null | undefined;
      readonly nineHolePrice: number | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined;
};
export type useGetBundledRateOptionsQuery = {
  response: useGetBundledRateOptionsQuery$data;
  variables: useGetBundledRateOptionsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "membershipTypeId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "nonPlayingHost"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "rateType"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "timeSlotId"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "transportationMemberId"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "transportationPlayerType"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "visibleToMembershipTypeId"
},
v7 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "timeSlotId"
  }
],
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v9 = [
  {
    "kind": "Variable",
    "name": "nonPlayingHost",
    "variableName": "nonPlayingHost"
  },
  {
    "kind": "Variable",
    "name": "type",
    "variableName": "rateType"
  },
  {
    "kind": "Variable",
    "name": "visibleToMembershipTypeId",
    "variableName": "visibleToMembershipTypeId"
  }
],
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "visibility",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": [
    {
      "kind": "Variable",
      "name": "membershipTypeId",
      "variableName": "membershipTypeId"
    }
  ],
  "kind": "ScalarField",
  "name": "appliesToMembershipType",
  "storageKey": null
},
v14 = [
  {
    "kind": "Literal",
    "name": "holeCount",
    "value": "NINE"
  }
],
v15 = {
  "alias": "nineHolePrice",
  "args": (v14/*: any*/),
  "kind": "ScalarField",
  "name": "totalGolfPrice",
  "storageKey": "totalGolfPrice(holeCount:\"NINE\")"
},
v16 = [
  {
    "kind": "Literal",
    "name": "holeCount",
    "value": "EIGHTEEN"
  }
],
v17 = {
  "alias": "eighteenHolePrice",
  "args": (v16/*: any*/),
  "kind": "ScalarField",
  "name": "totalGolfPrice",
  "storageKey": "totalGolfPrice(holeCount:\"EIGHTEEN\")"
},
v18 = {
  "alias": null,
  "args": [
    {
      "kind": "Variable",
      "name": "memberId",
      "variableName": "transportationMemberId"
    },
    {
      "kind": "Literal",
      "name": "memberVisible",
      "value": true
    },
    {
      "kind": "Variable",
      "name": "playerType",
      "variableName": "transportationPlayerType"
    }
  ],
  "concreteType": "TransportationType",
  "kind": "LinkedField",
  "name": "transportationTypes",
  "plural": true,
  "selections": [
    (v10/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "code",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "customCode",
      "storageKey": null
    },
    (v11/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "enabled",
      "storageKey": null
    },
    {
      "alias": "nineHolePrice",
      "args": (v14/*: any*/),
      "kind": "ScalarField",
      "name": "totalPrice",
      "storageKey": "totalPrice(holeCount:\"NINE\")"
    },
    {
      "alias": "eighteenHolePrice",
      "args": (v16/*: any*/),
      "kind": "ScalarField",
      "name": "totalPrice",
      "storageKey": "totalPrice(holeCount:\"EIGHTEEN\")"
    }
  ],
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "supportsPrivate",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "useGetBundledRateOptionsQuery",
    "selections": [
      {
        "alias": "slot",
        "args": (v7/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v8/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": "rates",
                "args": (v9/*: any*/),
                "concreteType": "SlotRate",
                "kind": "LinkedField",
                "name": "playerRates",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "rate",
                    "plural": false,
                    "selections": [
                      (v10/*: any*/),
                      (v11/*: any*/),
                      (v12/*: any*/),
                      (v13/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v15/*: any*/),
                  (v17/*: any*/)
                ],
                "storageKey": null
              },
              (v18/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Agenda",
                "kind": "LinkedField",
                "name": "agenda",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Facility",
                    "kind": "LinkedField",
                    "name": "facility",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Club",
                        "kind": "LinkedField",
                        "name": "club",
                        "plural": false,
                        "selections": [
                          (v19/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "type": "Slot",
            "abstractKey": "__isSlot"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "RootQueryType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v3/*: any*/),
      (v0/*: any*/),
      (v6/*: any*/),
      (v2/*: any*/),
      (v1/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/)
    ],
    "kind": "Operation",
    "name": "useGetBundledRateOptionsQuery",
    "selections": [
      {
        "alias": "slot",
        "args": (v7/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v8/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": "rates",
                "args": (v9/*: any*/),
                "concreteType": "SlotRate",
                "kind": "LinkedField",
                "name": "playerRates",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "rate",
                    "plural": false,
                    "selections": [
                      (v8/*: any*/),
                      (v10/*: any*/),
                      (v11/*: any*/),
                      (v12/*: any*/),
                      (v13/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v15/*: any*/),
                  (v17/*: any*/)
                ],
                "storageKey": null
              },
              (v18/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Agenda",
                "kind": "LinkedField",
                "name": "agenda",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Facility",
                    "kind": "LinkedField",
                    "name": "facility",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Club",
                        "kind": "LinkedField",
                        "name": "club",
                        "plural": false,
                        "selections": [
                          (v19/*: any*/),
                          (v10/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v10/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v10/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "type": "Slot",
            "abstractKey": "__isSlot"
          },
          (v10/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "937a265526b8ddfc4d655de81e15da39",
    "id": null,
    "metadata": {},
    "name": "useGetBundledRateOptionsQuery",
    "operationKind": "query",
    "text": "query useGetBundledRateOptionsQuery(\n  $timeSlotId: ID!\n  $membershipTypeId: ID\n  $visibleToMembershipTypeId: ID\n  $rateType: RateType!\n  $nonPlayingHost: Boolean\n  $transportationMemberId: ID\n  $transportationPlayerType: PlayerType\n) {\n  slot: node(id: $timeSlotId) {\n    __typename\n    ... on Slot {\n      __isSlot: __typename\n      rates: playerRates(type: $rateType, nonPlayingHost: $nonPlayingHost, visibleToMembershipTypeId: $visibleToMembershipTypeId) {\n        rate {\n          __typename\n          id\n          name\n          visibility\n          appliesToMembershipType(membershipTypeId: $membershipTypeId)\n        }\n        nineHolePrice: totalGolfPrice(holeCount: NINE)\n        eighteenHolePrice: totalGolfPrice(holeCount: EIGHTEEN)\n      }\n      transportationTypes(memberId: $transportationMemberId, memberVisible: true, playerType: $transportationPlayerType) {\n        id\n        code\n        customCode\n        name\n        enabled\n        nineHolePrice: totalPrice(holeCount: NINE)\n        eighteenHolePrice: totalPrice(holeCount: EIGHTEEN)\n      }\n      agenda {\n        facility {\n          club {\n            supportsPrivate\n            id\n          }\n          id\n        }\n        id\n      }\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "d29ff0f50ff488aed8fae7e174e640f6";

export default node;
